import React from "react";
import { Control, useWatch } from "react-hook-form";

import { formatCurrency } from "../../utils";
import { netAmountOf } from "../../utils/taxWithheld";
import { NetPreviewRow } from "./styles";
import { NetPreviewFields, NetPreviewProps } from "./types";

export const NetPreview = <TFieldValues extends NetPreviewFields>({
  control,
}: NetPreviewProps<TFieldValues>) => {
  // RHF can't resolve paths on a generic form, so watch through the shared field shape.
  const [grossAmount, taxWithheld] = useWatch({
    control: control as unknown as Control<NetPreviewFields>,
    name: ["amount", "taxWithheld"],
  });
  const netAmount = netAmountOf(grossAmount || 0, taxWithheld || 0);
  const formattedNet = formatCurrency(netAmount ?? 0);

  return (
    <NetPreviewRow aria-live="polite">
      <span>Net received</span>
      <span>{formattedNet}</span>
    </NetPreviewRow>
  );
};
